import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-394f88cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collapse" }
const _hoisted_2 = { class: "collapse__header-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "collapse__header-plus" }, "+", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "collapse__header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpened = !_ctx.isOpened))
    }, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _hoisted_3
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["collapse__body", { 'is-opened': _ctx.isOpened }])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2)
  ]))
}